<template>
  <div class="tw-w-full">
    <div v-if="quoteId !== null">
      <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-4 tw-mt-3 tw-mb-3 md:tw-mt-10">Please schedule an appointment for Vehicle Inspection <small v-if="!mustSchedule">(optional)</small></h3>

      <label for="radio-group" v-if="!mustSchedule1" class="tw-px-2 md:tw-px-4 tw-mt-3">Choose an option *</label>
      <v-radio-group id="radio-group" class="my-2 tw-px-0 md:tw-px-6" v-model="checked" :disabled="checked === 1" :rules="rules" @change="updateCheck" row>
        <v-radio label="Schedule now" :value="1" class="tw-mt-0 md:tw-mt-5 tw-pr-10"></v-radio>
        <v-radio v-if="!mustSchedule1" label="I will do it later" :value="2" class="tw-mt-0 md:tw-mt-5"></v-radio>
      </v-radio-group>
    </div>
    <div class="tw-flex tw-justify-between" v-else>
      <p class="c-yellow-text tw-italic tw-text-sm"><v-icon color="secondary">mdi-volume-high</v-icon> {{this.checked === '' ? 'Set up appointment for vehicle inspection.' : 'Appointment for vehicle inspection set up successful'}}</p>
      <span v-if="this.checked === ''" class="tw-bg-orange-500 tw-px-4 tw-py-0 tw-rounded-lg lg:tw-rounded-full tw-text-sm tw-cursor-pointer" @click="dialog=true">SCHEDULE</span>
    </div>

    <v-dialog v-model="dialog" persistent max-width="630px">
      <v-card>
        <v-card-text>
          <card-title>Kindly book inspection appointment</card-title>
          <v-container class="tw-mt-4 md:tw-mt-8">
            <v-form v-model="isValid">
              <v-row>
                <v-col cols="12" sm="6">
                  <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="computedDateFormatted"
                          label="Date"
                          persistent-hint
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[required('Date')]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date"
                        no-title
                        @input="menu = false"
                        :min="new Date().toLocaleDateString('en-CA')"
                        :allowed-dates="allowedDates"
                        color="primary"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-menu
                      ref="menu"
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="time"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="time"
                          label="Time"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[required('Time')]"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                        ampm-in-title
                        v-if="menu2"
                        v-model="time"
                        full-width
                        @click:minute="$refs.menu.save(time)"
                        :allowed-hours="allowedHours"
                        :min="timeNow(this.date)"
                        format="24hr"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-text-field v-model="location" ref="address" id="address" label="Your Location" type="text" :rules="[required('Location')]"></v-text-field>
                  <v-text-field type="text" v-model="coordinates" :rules="[isObjectField()]" class="tw-hidden"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                      v-model="terms"
                      label="I agree to share my details for scheduling the  inspection of my vehicle"
                      :rules="[check()]"
                  ></v-checkbox>
                </v-col>
                <v-card-actions class="col-sm-4 offset-sm-4">
                  <v-btn block large
                         color="secondary"
                         class="my-3 "
                         :disabled="!isValid"
                         @click="submit"
                         :loading="loading">
                    Submit
                  </v-btn>
                </v-card-actions>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CardTitle from '@/components/shared/CardTitle';
import { formatDate, reverseFormat, timeNow } from '@/utils/time';
import validations from '@/utils/validations';
import axios from 'axios';

const { Loader } = require('google-maps');

const options = { version: '3.40', language: 'en', libraries: ['places'] };
const loader = new Loader(process.env.VUE_APP_GOOGLE_MAPS_API_KEY, options);

export default {
  name: 'ScheduleInspection',
  props: {
    rules: {
      type: Array,
      required: false,
    },
    quoteId: {
      type: Number,
      required: false,
      default: null,
    },
    policyNumber: {
      type: String,
      required: false,
      default: null,
    },
    scheduled: Boolean,
    mustSchedule: {
      type: Boolean,
      default: true,
    },
  },
  components: { CardTitle },
  data: () => ({
    dialog: false,
    date: '',
    dateFormatted: '',
    menu: false,
    time: null,
    menu2: false,
    loading: false,
    checked: '',
    isValid: false,
    ...validations,
    terms: '',
    location: '',
    loaded: false,
    coordinates: '',
    inspect: 'INSPECT-',
    mustSchedule1: true,
  }),
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
    checked(val) {
      if (val === 1) {
        this.dialog = true;
      }
    },
  },
  mounted() {
    if (this.scheduled) {
      this.checked = 1;
    }
  },
  updated() {
    const ref = this;
    this.$nextTick(() => {
      if (typeof ref.$refs.address !== 'undefined' && !this.loaded) {
        ref.locationsAutoComplete();
      }
    });
  },
  methods: {
    submit() {
      this.loading = true;
      let data = {};
      if (this.quoteId !== null) {
        data = { ...this.coordinates, ...{ date: this.reverseFormat(this.dateFormatted), quoteId: this.quoteId, time: this.time } };
      } else {
        data = { ...this.coordinates, ...{ date: this.reverseFormat(this.dateFormatted), policyNumber: this.policyNumber, time: this.time } };
      }
      axios.post('/customer/quotation/evaluation/schedule', data)
      // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.$toast.success('Inspection Date successfully scheduled', 'Evaluation');
          this.loading = false;
          this.checked = 1;
          this.dialog = false;
          this.$root.$emit('inspection-scheduled', response.data.data);
        });
    },
    formatDate,
    reverseFormat,
    timeNow,
    allowedDates: (val) => ![0, 6].includes(new Date(val).getDay()),
    allowedHours: (val) => ![0, 1, 2, 3, 4, 5, 6, 7, 18, 19, 20, 21, 22, 23, 24].includes(val),
    updateCheck(val) {
      this.$emit('input', val);
    },
    async locationsAutoComplete() {
      this.loaded = true;

      this.coordinates = {
        latitude: 0.5992059,
        longitude: 34.779603,
      };

      loader.load().then((google) => {
        const input = document.getElementById('address');
        const autocomplete = new google.maps.places.Autocomplete(input, {
          // bounds: bangaloreBounds,
          componentRestrictions: { country: 'ke' },
          strictBounds: true,
        });

        google.maps.event.addListener(autocomplete, 'place_changed', () => {
          const place = autocomplete.getPlace();
          // eslint-disable-next-line no-unused-vars
          this.coordinates = {
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
          };
        });
      });
    },
    close() {
      this.dialog = false;
      this.checked = '';
    },
  },
};
</script>

<style>
.v-dialog{
  box-shadow: none!important;
}
</style>
